import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '18',
  height: '18',
  viewBox: '-1 -1 20 20'
}, [
  h('path', {
    fill: '#E25C50',
    d: 'M.8 16h16.5L9 1.8.8 16zm9-2.2H8.2v-1.5h1.5v1.5zm0-3H8.2v-3h1.5v3z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/note-warning.es6.js